<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <span>{{ $t('global.translation_update_title') }}</span>
          </b-col>
        </b-row>
      </div>
      <div v-if="spinners.contentIsLoading" class="text-center">
        <b-spinner type="grow" variant="primary"/>
      </div>
      <div v-else>
        <b-row>
          <b-col cols="12" md="4">
            <b-form-group>
              <label>{{ $t('global.language_id_text') }}</label>
              <b-form-input type="text"
                :placeholder="$t('global.language_id_placeholder')"
                :class="{ 'is-invalid' : errorMsg.language_id }"
                v-model="entity.language_id"/>
              <div class="invalid-feedback" v-if="errorMsg.name">{{ errorMsg.name[0] }}</div>
            </b-form-group>
            <b-form-group>
              <label>{{ $t('global.translation_group') }}</label>
              <b-form-input type="text"
                :placeholder="$t('global.translation_group_placeholder')"
                :class="{ 'is-invalid' : errorMsg.group }"
                v-model="entity.group"/>
              <div class="invalid-feedback" v-if="errorMsg.group">{{ errorMsg.group[0] }}</div>
            </b-form-group>
            <b-form-group>
              <label>{{ $t('global.translation_key') }}</label>
              <b-form-input type="text"
                :placeholder="$t('global.translation_key_placeholder')"
                :class="{ 'is-invalid' : errorMsg.key }"
                v-model="entity.key"/>
              <div class="invalid-feedback" v-if="errorMsg.key">{{ errorMsg.key[0] }}</div>
            </b-form-group>
            <b-form-group>
              <label>{{ $t('global.translation_text') }}</label>
              <b-form-input type="text"
                :placeholder="$t('global.translation_text_placeholder')"
                :class="{ 'is-invalid' : errorMsg.text }"
                v-model="entity.text"/>
              <div class="invalid-feedback" v-if="errorMsg.text">{{ errorMsg.text[0] }}</div>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <div slot="footer">
        <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="save()">
          <b-spinner v-if="spinners.isSaving" type="grow" small/>
          {{ $t('global.save') }}
        </b-button>
        <router-view :to="{ name: 'Translations' }">
          <b-button type="reset" variant="info" class="ml-2">{{ $t('global.cancel') }}</b-button>
        </router-view>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import VT from '@/store/types';

export default {
  mounted() {
    this.load();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: true,
        isSaving: false,
      },
      entity: {
        name: '',
      },
      errorMsg: {}
    };
  },
  components: {
  },
  computed: {
    isUpdateForm() {
      return this.id !== null;
    }
  },
  methods: {
    ...mapActions('Translations', {
      getForCreate: VT.TRANSLATION_CREATE_DATA,
      pushCreate: VT.TRANSLATION_CREATE,
    }),
    load() {
      this.getForCreate().then((data) => {
        this.spinners.contentIsLoading = false;
        // TODO
      });
    },
    save() {
      this.spinners.isSaving = true;
      this.pushCreate(this.entity).then((data) => {
        this.spinners.isSaving = false;
        this.alertSuccess();
        this.entity = data.data;
        Object.assign(this.$data, this.$options.data());
        this.load();
      }).catch((data) => {
        this.spinners.isSaving = false;
        this.errorMsg = data.data.data.errors;
        this.alertError();
      });
    },
  }
};
</script>

<style scoped>
</style>
